import { createStore } from 'vuex'
import avatar from './modules/avatar'
import benefiario from './modules/beneficiario' 
import cadastroIncompleto from './modules/cadastroIncompleto'
import campanhasAtivas from './modules/campanhasAtivas'
import chave from './modules/chave'
import contratacaoContrib from './modules/contratacaoContrib'
import contratacaoEmp from './modules/contratacaoEmp'
import contratacaoSeg from './modules/contratacaoSeg'
import cpf from './modules/cpf'
import dataBaseReserva from './modules/dataBaseReserva'
import dadosContratacaoBeneficio from './modules/dadosContratacaoBeneficio'
import dadosContratacaoResgate from './modules/dadosContratacaoResgate'
import dadosSimuladorEmprestimo from './modules/dadosSimuladorEmprestimo'
import dadosSimuladorSeguro from './modules/dadosSimuladorSeguro'
import documentosGerais from './modules/documentosGerais'
import email from './modules/email'
import emailCadastro from './modules/emailCadastro'
import isRP from './modules/isRP'
import listaBancos from './modules/listaBancos'
import listaChaves from './modules/listaChaves'
import login from './modules/login'
import novaChave from './modules/novaChave'
import parametrosSimuladorBeneficios from './modules/parametrosSimuladorBeneficios'
import parceiroSelecionado from './modules/parceiroSelecionado'
import participante from './modules/participante'
import perfilIvestimento from './modules/perfil_investimento'
import plano from './modules/plano'
import produtoSelecionado from './modules/produtoSelecionado'
import projetoFirebase from './modules/projetoFirebase'
import regimeTributacao from './modules/regime_tributacao'
import reservaSetting from './modules/reservaSetting'
import segmento from './modules/segmento'
import settingsDadosEntidade from './modules/settingsDadosEntidade'
import settingsSimuladorRenda from './modules/settingsSimuladorRenda'
import statusParticipacao from './modules/statusParticipacao'
import uid from './modules/uid'
import ultimaChave from './modules/ultimaChave'
import ultimoUid from './modules/ultimoUid'
import consultoriaAgendamento from './modules/consultoriaAgendamento'
import valorResgateSolicitado from './modules/valorResgateSolicitado'
import chavePrincipal from './modules/chavePrincipal'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    avatar,
    benefiario,
    cadastroIncompleto,
    campanhasAtivas,
    consultoriaAgendamento,
    chave,
    contratacaoContrib,
    contratacaoEmp,
    contratacaoSeg,
    cpf,
    dataBaseReserva,
    dadosContratacaoBeneficio,
    dadosContratacaoResgate,
    dadosSimuladorEmprestimo,
    dadosSimuladorSeguro,
    documentosGerais,
    email,
    emailCadastro,
    isRP,
    listaBancos,
    listaChaves,
    login,
    novaChave,
    parametrosSimuladorBeneficios,
    parceiroSelecionado,
    participante,
    perfilIvestimento,
    plano,
    produtoSelecionado,
    projetoFirebase,
    regimeTributacao,
    reservaSetting,
    segmento,
    settingsDadosEntidade,
    settingsSimuladorRenda,
    statusParticipacao,
    uid,
    ultimaChave,
    ultimoUid,
    valorResgateSolicitado,
    chavePrincipal
  }
})